export var isShortDate = date => /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/.test(date);